<template>
<div v-if="isEdit">
  <el-autocomplete size="small" v-model="listQuery.key" :fetch-suggestions="querySearchAsync" :placeholder="disabled?'禁用':'请选择'" :disabled="disabled" :trigger-on-focus="false" :debounce=0 @select="handleSelect" @blur="checkinput" :value-key="nameKey">
    <!-- <i class="el-icon-search" slot="suffix" @click="dialogAccessCustum = true"></i> -->
    <!-- <i class="el-icon-s-promotion" slot="suffix" @click="dialogAccessCustum = true"></i> -->
    <el-button slot="append" icon="el-icon-search" @click="dialogAccessCustum = true" :disabled="disabled"></el-button>
    <el-button slot="prepend" icon="el-icon-s-promotion"  @click="showDrawer" :disabled="disabled"></el-button>
    </el-autocomplete>

  <el-dialog class="dialog-mini" top="15vh" v-el-drag-dialog :title="'选择记录'" :visible.sync="dialogAccessCustum">
      <access-new ref="accessNew" v-if="dialogAccessCustum"   @close="dialogAccessCustum=false" @closeMoule="closeMoule" :returnKey="returnKey" :otherQuery="otherQuery" :apiName="apiName" :idKey="idKey"
       :nameKey="nameKey" :getDataMethod="getDataMethod" ></access-new>
  </el-dialog>
  <drawerViews :drawer.sync="drawer" :tempobj="drawertemp" :objtype="apiName" :menukeyArray="menukeyArray"></drawerViews>
</div>
<div v-else>
  <show-form-detailed
    ref="ShowFormDetailed"
    :id="id"
    :name="name"
    :api-name="apiName"
  ></show-form-detailed>

</div>
</template>

<script>
import accessNew from '@/components/SelectNew';// 选择机会弹窗
import elDragDialog from '@/directive/el-dragDialog';
import request from '@/utils/request';
import ShowFormDetailed from '@/components/ShowFormDetailed';
import { mapGetters } from 'vuex';

export default {
  name: 'auto-new',
  components: { accessNew, ShowFormDetailed },
  directives: { elDragDialog },
  props: {
    id: [String, Number],
    name: [String, Number],
    idKey: [String],
    nameKey: [String],
    otherQuery: {
      type: Array,
      // default() {
      //   return []
      // }
      default() {
        return [{
          key: '',
          relation: '',
          value: ''
        }];
      }
    },
    returnKey: {
      type: Array,
      default() {
        return [{
          querykey: '',
          modelkey: ''
        }];
      }
    },
    getDataMethod: {
      type: String,
      default: 'load'
    },
    apiName: {
      type: String,
      required: true
    },
    isEdit: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      list: [],
      dialogAccessCustum: false, // select customer dialog
      compobject: {
      },
      drawer: false,
      drawertemp: {},
      listQuery: { // 查询条件
        page: 1,
        limit: 20,
        appId: undefined,
        key: undefined
      }
    };
  },
  created() {
    // this.listQuery = { ...this.listQuery, ...this.parmObj }
  },
  watch: {
    name(val) {
      this.listQuery.key = val;
      if (val !== '') {
        const tempobj = {};
        tempobj[this.nameKey] = this.name;
        this.list.push(tempobj);
      }
    },
    id(val) {
      if (val === '') {
        this.listQuery.key = val;
        this.$emit('update:name', val);
      }
    }
  },
  mounted() {
    this.listQuery.key = this.name;
    if (this.name !== '') {
      const tempobj = {};
      tempobj[this.nameKey] = this.name;
      this.list.push(tempobj);
    }
  },
  computed: {
    ...mapGetters(['currentAccId']),
    menukeyArray() {
      return [{ name: '基本信息', menukey: this.apiName.toLowerCase() + 'view' }];
    }
  },
  methods: {
    showDrawer() {
      if (this.id !== '') {
        this.getByApi(this.id).then(response => {
          this.drawertemp = { ...this.drawertemp, ...response.result };
          this.drawer = true;
        }).catch(() => {
          // console.log(err)
        });
      }
    },
    getListByApi(data) {
      return request({
        url: '/' + this.apiName + '/' + this.getDataMethod,
        method: 'post',
        data
      });
    },
    getByApi(id) {
      return request({
        url: '/' + this.apiName + '/get',
        method: 'get',
        params: { id: id }
      });
    },
    closeMoule(obj) { // 选择框触发事件
      this.compobject = { ...{}, ...obj };
      this.list = obj.list;
      this.listQuery.key = obj[this.nameKey];
      this.dialogAccessCustum = false;

      this.postselval(this.compobject);
    },
    querySearchAsync(queryString, cb) { // autocomplete查询触发
      const _this = this;
      const tempotherQuery = _this.otherQuery.filter(m =>
        m.key && m.key !== '' && m.value && m.value !== ''
      );

      const wheresObj = [];
      if (tempotherQuery.length > 0) {
        tempotherQuery.forEach(item => {
          wheresObj.push({
            field: item.key,
            value: item.value === '{{AccountId}}' ? this.currentAccId : item.value,
            relation: item.relation ? item.relation : '=='
          });
        });
      }

      wheresObj.push({
        field: this.nameKey,
        value: this.listQuery.key,
        relation: 'contains'
      });
      _this.listQuery.wheres = JSON.stringify(wheresObj);

      _this.listQuery[this.nameKey] = _this.listQuery.key;

      _this.listQuery.AccountId = this.currentAccId;
      _this.getListByApi(_this.listQuery).then(response => {
        _this.list = response.data;
        cb(_this.list);
      });
    },
    handleSelect(item) { // 下拉框点击返回
      this.returnKey.filter(m => m.querykey !== '' && m.modelkey !== '').forEach(m => {
        this.compobject[m.modelkey] = item[m.querykey];
      });
      this.listQuery.key = item[this.nameKey];
      this.compobject.name = item[this.nameKey];
      this.compobject.id = item[this.idKey];
      this.postselval(this.compobject);
    },
    checkinput() { // 下拉框失去焦点
      var result = this.list.find(u => u[this.nameKey] === this.listQuery.key);
      if (result === undefined) {
        this.returnKey.filter(m => m.querykey !== '' && m.modelkey !== '').forEach(m => {
          this.compobject[m.modelkey] = '';
        });
        this.listQuery.key = '';
        if (this.otherQuery.length > 0) {
          this.otherQuery.forEach(m => {
            if (m.key && m.key !== '') {
              this.listQuery[m.key] = '';
            }
          });
        }
        this.postselval(this.compobject);
      }
    },
    postselval(val) { // 子组件传值触发事件
      this.$emit('update:name', val.name);
      this.$emit('update:id', val.id);
      this.$emit('change', val);
      // console.log(val)
      const keysAray = Object.keys(val).filter(item => {
        return item !== 'id' && item !== 'name';
      });
      if (keysAray.length > 0) {
        const postObj = {};
        keysAray.forEach(item => {
          postObj[item] = val[item];
        });
        this.$emit('postdata', postObj);
      }
    }
  }
};
</script>
<style>
  .el-autocomplete {
    width: 100%;
  }
</style>
